import { render, staticRenderFns } from "./changeBook.vue?vue&type=template&id=081245cc&scoped=true&"
import script from "./changeBook.vue?vue&type=script&lang=js&"
export * from "./changeBook.vue?vue&type=script&lang=js&"
import style0 from "./changeBook.vue?vue&type=style&index=0&id=081245cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081245cc",
  null
  
)

export default component.exports